require('./src/errors/errors.js');
require('./polyfills');
require('./vendor.js');

angular.module('kareo.ui.shared.directives.templates', []);

// http://webpack.github.io/docs/context.html#dynamic-requires
var req = require.context('./src', true, /^(?=.*\.(js|coffee)$)(?!.*\.(?:spec|mock|stories)\.)(?!.*\/(?:docs|config-environments)\/).*$/);
req.keys().forEach((key) => req(key));

// req.keys returns all possible requests that the context can handle
// req(key) - does this make the context load the corresponding module for the specified key?


require('./src/config-environments/config.js');

require('./src/modules/fullstory/index.js');
